module.exports = __webpack_public_path__ + "static/hume-88cf8f793d6450de32996939e9b6d711.jpg";